<main class="check">
  <header [attr.id]="data.title">
    <h3 [class.error]="!data.isPassed">{{ data.title }}</h3>
  </header>

  <div *ngIf="!(readonly || printPreview)">
    <mat-form-field appearance="fill">
      <mat-select [(ngModel)]="inspectionType">
        <mat-option *ngFor="let type of pressureSystemTypes" [value]="type">{{
          type
        }}</mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field class="numerical" floatLabel="always" appearance="fill">
      <mat-label *ngIf="!isCorridor(inspectionType)"
        >כמות חדרי מדרגות</mat-label
      >
      <mat-label *ngIf="isCorridor(inspectionType)"
        >כמות מסדרונות מילוט</mat-label
      >
      <input
        type="number"
        min="0"
        matInput
        placeholder="0"
        [(ngModel)]="numOfStairsRooms"
      />
    </mat-form-field>
    <mat-form-field class="numerical" floatLabel="always" appearance="fill">
      <mat-label *ngIf="!isCorridor(inspectionType)">כמות קומות</mat-label>
      <mat-label *ngIf="isCorridor(inspectionType)">כמות דלתות</mat-label>
      <input
        type="number"
        min="0"
        matInput
        placeholder="0"
        [(ngModel)]="numOfFloors"
      />
    </mat-form-field>
    <mat-form-field
      class="numerical"
      floatLabel="always"
      appearance="fill"
      *ngIf="!isCorridor(inspectionType)"
    >
      <mat-label>קומה ראשונה מתחילה מקומה</mat-label>
      <input
        type="number"
        matInput
        placeholder="0"
        [(ngModel)]="floorStartsAt"
      />
    </mat-form-field>
    <button
      color="accent"
      mat-raised-button
      aria-label="create tables"
      (click)="createTables()"
    >
      <span>צור טבלאות בדיקה</span>
    </button>
  </div>

  <div *ngIf="printPreview">
    <mat-card
      class="mat-elevation-z4"
      *ngFor="let stairsRoom of data.stairsRooms; let ind = index"
    >
      <mat-card-header>
        <mat-card-title>{{
          getStairsName(stairsRoom.type, ind)
        }}</mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <ng-container
          *ngTemplateOutlet="
            printPreviewTpl;
            context: { stairsRoom: stairsRoom, ind: ind }
          "
        ></ng-container>
      </mat-card-content>
    </mat-card>
  </div>

  <mat-tab-group
    class="mat-elevation-z4"
    *ngIf="data.stairsRooms.length > 0 && !printPreview"
    animationDuration="0ms"
  >
    <mat-tab *ngFor="let stairsRoom of data.stairsRooms; let ind = index">
      <ng-template mat-tab-label>
        <mat-icon class="fail" color="warn" *ngIf="!isPassed(stairsRoom)">
          priority_high
        </mat-icon>
        <span>{{ getStairsName(stairsRoom.type, ind) }}</span>
      </ng-template>
      <ng-template matTabContent>
        <ng-container
          *ngTemplateOutlet="
            formTpl;
            context: { stairsRoom: stairsRoom, ind: ind }
          "
        ></ng-container>
      </ng-template>
    </mat-tab>
  </mat-tab-group>

  <ng-container *ngFor="let item of data.cases">
    <section
      class="check-cases"
      [class.border]="item.isApplicable"
      [attr.id]="item.title"
    >
      <mat-slide-toggle
        [color]="item.isPassed ? 'primary' : 'warn'"
        [(ngModel)]="item.isApplicable"
        (change)="onDataChange()"
        *ngIf="!(readonly || printPreview)"
      >
        <span class="title" [class.error]="item.isApplicable && !item.isPassed"
          ><span>{{ item.section }}. </span> <span>{{ item.title }}</span></span
        >
      </mat-slide-toggle>
      <span
        class="title"
        [class.error]="item.isApplicable && !item.isPassed"
        *ngIf="readonly || printPreview"
        ><span>{{ item.section }}. </span>
        <span>{{ item.title }}</span>
      </span>
      <div class="cases" *ngIf="item.isApplicable">
        <ng-container *ngFor="let c of item.subCases">
          <authority-labs-check-case
            style="display: block"
            [style.margin-right]="margin(item.section, c.section)"
            *ngIf="isParentShown(item.section, c.section)"
            (dataChange)="onDataChange()"
            [printPreview]="printPreview"
            [readonly]="readonly"
            [inspection]="c"
          ></authority-labs-check-case>
        </ng-container>
      </div>
    </section>
  </ng-container>
</main>

<ng-template #formTpl let-stairsRoom="stairsRoom" let-ind="ind">
  <mat-slide-toggle
    class="sprinklers-toggle"
    [(ngModel)]="stairsRoom.withSprinklers"
    *ngIf="!readonly"
    (change)="toggleWithSprinklers()"
  >
    <span>{{
      toggleSprinklersTitle(stairsRoom.type, stairsRoom.withSprinklers)
    }}</span>
  </mat-slide-toggle>
  <cdk-virtual-scroll-viewport
    #scrollViewport
    [itemSize]="itemSize"
    [style.height.px]="tableHeight"
    *ngFor="
      let s of [
        {
          name: 'closedDoorsStairsName',
          floors: stairsRoom.closedDoorsFloors
        },
        {
          name: 'openDoorsStairsName',
          floors: stairsRoom.openDoorsFloors
        }
      ];
      let i = index
    "
  >
    <table class="mat-table" [class.print-preview]="printPreview">
      <thead [style.top.px]="inverseOfTranslation(i)">
        <ng-container
          *ngTemplateOutlet="
            tableHeadTpl;
            context: { stairsRoom: stairsRoom, s: s }
          "
        ></ng-container>
      </thead>
      <tbody>
        <ng-container *cdkVirtualFor="let item of s.floors">
          <ng-container
            *ngTemplateOutlet="
              tableBodyTpl;
              context: { stairsRoom: stairsRoom, item: item, ind: ind, i: i }
            "
          ></ng-container>
        </ng-container>
      </tbody>
    </table>
  </cdk-virtual-scroll-viewport>
</ng-template>

<ng-template #printPreviewTpl let-stairsRoom="stairsRoom" let-ind="ind">
  <h3>
    {{ toggleSprinklersTitle(stairsRoom.type, stairsRoom.withSprinklers) }}
  </h3>
  <div
    style="margin-bottom: 20px"
    *ngFor="
      let s of [
        {
          name: 'closedDoorsStairsName',
          floors: stairsRoom.closedDoorsFloors
        },
        {
          name: 'openDoorsStairsName',
          floors: stairsRoom.openDoorsFloors
        }
      ];
      let i = index
    "
  >
    <table class="mat-table" class="print-preview">
      <thead>
        <ng-container
          *ngTemplateOutlet="
            tableHeadTpl;
            context: { stairsRoom: stairsRoom, s: s }
          "
        ></ng-container>
      </thead>
      <tbody>
        <ng-container *ngFor="let item of s.floors">
          <ng-container
            *ngTemplateOutlet="
              tableBodyTpl;
              context: { stairsRoom: stairsRoom, item: item, ind: ind }
            "
          ></ng-container>
        </ng-container>
      </tbody>
    </table>
  </div>
</ng-template>

<ng-template #tableHeadTpl let-stairsRoom="stairsRoom" let-s="s">
  <tr class="mat-header-row">
    <th class="mat-header-cell mat-column-title" colspan="9">
      <span *ngIf="readonly || printPreview">{{ stairsRoom[s.name] }}</span>
      <mat-form-field *ngIf="!(readonly || printPreview)">
        <input
          type="text"
          matInput
          [(ngModel)]="stairsRoom[s.name]"
          (input)="onDataChange()"
        />
      </mat-form-field>
    </th>
  </tr>
  <tr class="mat-header-row">
    <th class="mat-header-cell mat-column-door" rowspan="2">
      <span>דלת פתוחה / סגורה</span>
    </th>
    <th class="mat-header-cell mat-column-floorNumber" rowspan="2">
      <span> {{ isCorridor(stairsRoom.type) ? 'דלת' : 'קומה' }}</span>
    </th>
    <th class="mat-header-cell" colspan="2">
      <span>כח פתיחת דלת (Kg)</span>
    </th>
    <th class="mat-header-cell" colspan="2">
      <span>מהירות זרימת אוויר (m/s)</span>
    </th>
    <th class="mat-header-cell" colspan="2">
      <span>הפרש לחצים (mbar)</span>
    </th>
    <th class="mat-header-cell mat-column-conclusion" rowspan="2">
      <span>מסקנה</span>
    </th>
  </tr>
  <tr class="mat-header-row">
    <th class="mat-header-cell">
      <span>נמדד</span>
    </th>
    <th class="mat-header-cell">
      <span>מקס'</span>
    </th>
    <th class="mat-header-cell">
      <span>מינ' נדרש</span>
    </th>
    <th class="mat-header-cell">
      <span>נמדד</span>
    </th>
    <th class="mat-header-cell">
      <span>מינימום נדרש</span>
    </th>
    <th class="mat-header-cell">
      <span>הפרש לחצים</span>
    </th>
  </tr>
</ng-template>

<ng-template
  #tableBodyTpl
  let-stairsRoom="stairsRoom"
  let-item="item"
  let-ind="ind"
  let-i="i"
>
  <tr class="mat-row">
    <td class="mat-cell mat-column-door">
      <span *ngIf="readonly || printPreview || i === 0">{{
        item.doorState
      }}</span>
      <mat-select
        *ngIf="!(readonly || printPreview) && i === 1"
        [(ngModel)]="item.doorState"
        (selectionChange)="doorToggle(stairsRoom.withSprinklers, item)"
      >
        <mat-option *ngFor="let state of doorStates" [value]="state">
          {{ state }}
        </mat-option>
      </mat-select>
    </td>
    <td class="mat-cell mat-column-floorNumber">
      <span *ngIf="readonly || printPreview">{{ item.floorNumber }}</span>
      <mat-form-field *ngIf="!(readonly || printPreview)">
        <textarea
          matInput
          class="text"
          cdkTextareaAutosize
          name="name"
          [(ngModel)]="item.floorNumber"
          (input)="onDataChange()"
        ></textarea>
      </mat-form-field>
    </td>
    <td class="mat-cell mat-column-doorOpeningPowerValue">
      <span *ngIf="readonly || printPreview || isOpenDoor(item.doorState)">{{
        item.doorOpeningPower?.messured
      }}</span>
      <mat-form-field
        *ngIf="!(readonly || printPreview || isOpenDoor(item.doorState))"
      >
        <input
          type="number"
          matInput
          [(ngModel)]="item.doorOpeningPower.messured"
          (input)="onValueChange(item)"
        />
      </mat-form-field>
    </td>
    <td class="mat-cell mat-column-doorOpeningPowerMaxValue">
      <span>{{ item.doorOpeningPower?.max }}</span>
    </td>
    <td class="mat-cell mat-column-airFlowSpeedMinValue">
      <span>{{ item.airFlowSpeed?.min }}</span>
    </td>
    <td class="mat-cell mat-column-airFlowSpeedValue">
      <span *ngIf="readonly || printPreview || !isOpenDoor(item.doorState)">{{
        item.airFlowSpeed?.messured
      }}</span>
      <mat-form-field
        *ngIf="!(readonly || printPreview || !isOpenDoor(item.doorState))"
      >
        <input
          type="number"
          matInput
          [(ngModel)]="item.airFlowSpeed.messured"
          (input)="onValueChange(item)"
        />
      </mat-form-field>
    </td>
    <td class="mat-cell mat-column-differentialPressureMinValue">
      <span>{{ item.differentialPressure?.min }}</span>
    </td>
    <td class="mat-cell mat-column-differentialPressureValue">
      <span *ngIf="readonly || printPreview || isOpenDoor(item.doorState)">{{
        item.differentialPressure?.messured
      }}</span>
      <mat-form-field
        *ngIf="!(readonly || printPreview || isOpenDoor(item.doorState))"
      >
        <input
          type="number"
          matInput
          [(ngModel)]="item.differentialPressure.messured"
          (input)="onValueChange(item)"
        />
      </mat-form-field>
    </td>
    <td class="mat-cell">
      <span *ngIf="item.isPassed">מתאים</span>
      <span class="error" *ngIf="!item.isPassed">לא מתאים</span>
    </td>
  </tr>
</ng-template>
